<template>
  <span class='video-playlist-row-container' :class="PlaylistRowClass">
    <div class='d-flex flex-row'>
      <div class='col-sm-12'>
        <h4 class='video-playlist-header' v-bind:class="playlistHeaderClass">{{videoPlaylist.name}}</h4>
      </div>
    </div>
    <!-- GRID VIEW -->
    <div class='d-flex flex-row flex-wrap placeholder-video-cards-row' v-if="!videoPlaylist.video_assets_fetched && gridView">
      <div class='col-sm-12 col-md-3'
        v-for="(_, i) in [1,2,3]" :key="i">
        <PlaceholderVideoCard>
        </PlaceholderVideoCard>
      </div>
    </div>
    <div class='d-flex flex-row flex-wrap video-cards-row video-cards-grid' v-if="videoPlaylist.video_assets_fetched && gridView">
      
      <div class='col-sm-12 col-md-3' 
        v-for="videoAssetVideoPlaylist in videoAssetVideoPlaylists" :key="videoAssetVideoPlaylist.id">
        <VideoCard 
          v-bind:video-asset="videoAssetVideoPlaylist.video_asset"
          v-bind:video-asset-video-playlist="videoAssetVideoPlaylist"
        >
        </VideoCard>
      </div>

      <div class='col-sm-12 col-md-3' v-for="(_, i) in placeholderRows" :key="getPlaceholderKey(i)">
        <PlaceholderVideoCard>
        </PlaceholderVideoCard>
      </div>

    </div>

    <div class='d-flex flex-row' v-if="gridView">
      <div class='col-sm-12'>
        <button v-if="hasNextPage && !fetchingMoreVideoAssets" v-on:click="emitGetNextPage()">
          Get More
        </button>
      </div>
    </div>
    <!-- END GRID VIEW -->
    <!-- LIST VIEW -->
    <div class='d-flex flex-row flex-wrap placeholder-video-cards-row' v-if="!videoPlaylist.video_assets_fetched && listView">
      <div class='col-sm-12'
        v-for="(_, i) in [1,2,3]" :key="i">
        <PlaceholderVideoCardList>
        </PlaceholderVideoCardList>
      </div>
    </div>
    <div class='d-flex flex-row flex-wrap video-cards-row video-cards-list' v-if="videoPlaylist.video_assets_fetched && listView">
      <div class='col-sm-12' 
        v-for="videoAssetVideoPlaylist in videoAssetVideoPlaylists" :key="videoAssetVideoPlaylist.id">
        <VideoCardList 
          v-bind:video-asset="videoAssetVideoPlaylist.video_asset"
          v-bind:video-asset-video-playlist="videoAssetVideoPlaylist"
        >
        </VideoCardList>
      </div>

      <div class='col-sm-12' v-for="(_, i) in placeholderRows" :key="getPlaceholderKey(i)">
        <PlaceholderVideoCardList>
        </PlaceholderVideoCardList>
      </div>
    </div>

    <div class='d-flex flex-row' v-if="listView">
      <div class='col-sm-12'>
        <button v-if="hasNextPage && !fetchingMoreVideoAssets" v-on:click="emitGetNextPage()">
          Get More
        </button>
      </div>
    </div>
    <!-- END LIST VIEW -->
  </span>
</template>

<script>
import VideoCard from '../video-playlists/VideoCard.vue'
import VideoCardList from '../video-playlists/VideoCardList.vue'
import PlaceholderVideoCard from '../video-playlists/PlaceholderVideoCard.vue'
import PlaceholderVideoCardList from '../video-playlists/PlaceholderVideoCardList.vue'

export default {
  components: {
    VideoCard,
    VideoCardList,
    PlaceholderVideoCard,
    PlaceholderVideoCardList
  },

  props: {
    videoPlaylist: {
      type: Object,
      required: true
    },
    videoAssetsFetched: {
      type: Boolean,
      default: false
    },
    layout: {
      type: String,
      default: 'grid'
    }
  },

  methods: {

    getPlaceholderKey: function(i) {
      return 'placeholder-' + i
    },
    
    emitGetNextPage: function() {
      window.EventBus.$emit('get-next-page', this.videoPlaylist)
    }
  },

  computed: {

    gridView: function () {
      return this.layout == 'grid' || this.layout != 'list'
    },

    listView: function () {
      return this.layout == 'list'
    },

    PlaylistRowClass: function () {
      return `video-playlist-row-${this.videoPlaylist.id}`
    },

    playlistHeaderClass: function() {
      return `video-playlist-header-${this.videoPlaylist.id}`
    },

    videoAssetVideoPlaylists: function() {
      return this.videoPlaylist.video_assets && this.videoPlaylist.video_assets.data
    },
  
    videoAssetVideoPlaylistsPaginator: function () {
      return this.videoPlaylist.video_assets
    },

    hasNextPage: function () {
      return this.videoAssetVideoPlaylistsPaginator.next_page_url
    },

    fetchingMoreVideoAssets: function () {
      return this.videoPlaylist.fetching_more_video_assets
    },

    placeholderRows: function () {
      return this.fetchingMoreVideoAssets ? [1, 2] : []
    }

  }
}
</script>